// @ts-nocheck
import React from 'react';

import './styles.scss';

type Props = {
  icon: string;
  onClick: () => void;
};

function ActionButton({ icon, onClick }: Props) {
  return (
    <span className="actionButton">
      {/* biome-ignore lint/a11y/useButtonType: off */}
      <button className="actionButton__button" onClick={onClick}>
        <i className={icon} />
      </button>
    </span>
  );
}

export default ActionButton;
